import { resourceHelper } from './helpers';
import app from '$$app';

async function onTaskResourceUnassigned(event) {
  const { data, innerSettings } = event;
  let taskIds = [];

  if (innerSettings.projectId) {
    taskIds = resourceHelper(data.unassignedResources, +innerSettings.projectId, innerSettings.resourcesToTasks);
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    projects: [event.innerSettings.projectId],
    tasks: taskIds,
    unassignedResources: data.unassignedResources,
  });
}

export default onTaskResourceUnassigned;
